import React from 'react';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import { configurationCodes } from '@/configurations/constants';

const ApprovalAction = ({ show, disabled }) => (
  <RibbonMenu
    name="auto-approve"
    icon="cog"
    message="actions.autoapprove"
    onClick={() => show(configurationCodes.DEFAULT_APPROVAL)}
    disabled={disabled}
    className="aridhia-auto-approve-action-menu"
  />
);

export default ApprovalAction;
